var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rank-list mt10" }, [
    _vm.tableData.length === 0
      ? _c("div", [
          !_vm.searchFail
            ? _c("p", { staticClass: "color99 font16 dfcjc" }, [
                _c("i", {
                  staticClass: "iconfont-npm icon-npm-jinggaotishi1 mr10",
                  staticStyle: { "font-size": "30px", color: "#ccc" },
                }),
                _vm._v("请输入关键词进行查询 "),
              ])
            : _c(
                "div",
                {
                  staticClass: "dfcjc search-fail",
                  staticStyle: { "align-items": "flex-start" },
                },
                [
                  _c("i", {
                    staticClass: "iconfont-npm icon-npm-jinggaotishi1 mr10",
                    staticStyle: { "font-size": "30px", color: "#ff9000" },
                  }),
                  _c(
                    "div",
                    { staticClass: "ml10" },
                    [
                      _c("p", [
                        _vm._v(" 在第 "),
                        _c("em", { staticStyle: { color: "#ff9000" } }, [
                          _vm._v(_vm._s(_vm.pageRange[0])),
                        ]),
                        _vm._v(" 至第 "),
                        _c("em", { staticStyle: { color: "#ff9000" } }, [
                          _vm._v(_vm._s(_vm.pageRange[1])),
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.port === 0 ? " 页" : " 个")),
                        ]),
                        _vm._v("，此关键词，未搜索到当前产品信息 "),
                      ]),
                      _vm.linkToAnalysis
                        ? [
                            _c("p", [_vm._v("建议您：")]),
                            _c("p", [
                              _vm._v(" 1 . 查看"),
                              _c(
                                "a",
                                {
                                  staticStyle: { color: "#2b97d9" },
                                  attrs: { href: "javascript:void(0);" },
                                  on: { click: _vm.suggest },
                                },
                                [_vm._v("优化建议")]
                              ),
                              _vm._v("，提升产品质量，获得更多曝光！ "),
                            ]),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
        ])
      : _c(
          "div",
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.listData,
                  stripe: "",
                  "header-cell-style": _vm.tableHeader,
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    label: "关键词",
                    align: "center",
                    "header-align": "center",
                    width: "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "textOver",
                              attrs: { title: row.keyword },
                            },
                            [_vm._v(_vm._s(row.keyword))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "",
                    align: "center",
                    "header-align": "center",
                    width: "84",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "a",
                            {
                              staticStyle: { width: "64px" },
                              attrs: {
                                href: `https://detail.1688.com/offer/${row.ProductInfo.ProductId}.html?token=${_vm.token}`,
                                target: "_blank",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  "max-width": "64px",
                                  "max-height": "64px",
                                },
                                attrs: {
                                  src: `https://cbu01.alicdn.com/${row.ProductInfo.Image.images[0]}`,
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "产品信息", "header-align": "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("a", {
                            staticStyle: { display: "block" },
                            attrs: {
                              href: `https://detail.1688.com/offer/${row.ProductInfo.ProductId}.html?token=${_vm.token}`,
                              target: "_blank",
                            },
                            domProps: { innerHTML: _vm._s(row.title) },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "企业实力",
                    align: "center",
                    "header-align": "center",
                    width: "115",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.shilitag
                            ? _c("img", {
                                staticStyle: { "vertical-align": "middle" },
                                attrs: {
                                  src: `${_vm.domain}tools/dzPopup/icon/strengthIcon.png`,
                                },
                              })
                            : _vm._e(),
                          _c("img", {
                            staticClass: "ml5",
                            staticStyle: { "vertical-align": "middle" },
                            attrs: {
                              src: `${_vm.domain}tools/dzPopup/icon/chengIcon.png`,
                            },
                          }),
                          _vm._v(_vm._s(row.companyTag) + " "),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.port === 0 ? "90天成交量" : "90天成交额",
                    align: "center",
                    "header-align": "center",
                    width: "95",
                    prop: "tradeBt",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "类型",
                    align: "center",
                    "header-align": "center",
                    width: "80",
                    prop: "type",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "排名位置",
                    align: "center",
                    "header-align": "center",
                    width: "115",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("p", [
                            _vm._v(" 第"),
                            _c("em", { staticStyle: { color: "#ff9000" } }, [
                              _vm._v(_vm._s(row.pageIndex)),
                            ]),
                            _vm._v("个 "),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    align: "center",
                    "header-align": "center",
                    width: "90",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm.linkToAnalysis
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToLink(row)
                                    },
                                  },
                                },
                                [_vm._v("点击分析")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm.showPagination
              ? _c(
                  "div",
                  { staticClass: "tc mt10" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.query.index,
                        "page-size": _vm.query.size,
                        background: "",
                        layout: "prev, pager, next,total, jumper",
                        total: _vm.totalNum,
                      },
                      on: { "current-change": _vm.handleCurrentChange },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }